<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <v-select
      :class="evaluateClasses(classes)"
      :label="caption"
      :disabled="isDisabled"
      :regular="isRegular"
      :solo="isSolo"
      :outlined="isOutlined"
      :filled="isFilled"
    ></v-select>
  </dr-wrapper>
  <v-select
      v-else-if="isVisible" 
      v-model="value"
      ref="drComboBoxRef"
      :class="evaluateClasses(classes)"
      :items="items"
      :label="caption"
      :disabled="isDisabled"
      :regular="isRegular"
      :solo="isSolo"
      :outlined="isOutlined"
      :filled="isFilled" 
      :clearable="isClearable"
      :multiple="isMultiple"
      :rules="_isRequiredField"
      @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })"
    >
      <template v-if="caption || model.Required" #label>
        <span v-if="caption">{{ caption }}</span>
        <span v-if="model.Required" class="dr-combo-box-required-hint">*</span>
      </template>
    </v-select>
</template>

<script>
import inputWidgetsWrapperMixin from '../../mixins/input-widgets-wrapper-mixin'
import inputWidgetsValidateMixin from '../../mixins/input-widgets-validate-mixin'
import inputMixin from '../../mixins/input-mixin'
import baseMixin from '../../mixins/base-mixin'
import actionMixin from '../../mixins/actions-mixin'

export default {
  mixins: [inputMixin, baseMixin, actionMixin, inputWidgetsWrapperMixin, inputWidgetsValidateMixin],
  computed: {
    _isRequiredField() {
      if (!this.model.Required) {
        return []
      }
      return [val => (val || '').length > 0 || `${this.model.Caption} - ${this.$t('vuetifyWidgets.dr-text-field.required')}`]
    },
    value: {
      get() {
        return this.getDataSourceField(this.model.Value)
      },
      set(val) {
        this.setDataSourceField(this.model.Value, val)
      }
    },
    items() {
      return this.getDataSourceField(this.model.Items)
    },
    caption() {
      return this.evaluateExpression(this.model.Caption)
    },
    isClearable() {
      return this.model.IsClearable
    },
    isMultiple() {
      return this.model.IsMultiple
    }
  }
}
</script>

<style>
.dr-combo-box-required-hint {
  font-size: 25px;
  color: red;
}
</style>